import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../core/authentication.service';
import { Observable, of } from 'rxjs';
import { AppSettings } from '../shared/App-Settings';
import { tap, catchError } from 'rxjs/operators';
import { ResponseDTO } from '../models/response-dto';
import { InvoiceFilterOption } from '../searchFilters/invoiceFilterOption';
import { fil } from 'date-fns/locale';

const apiUrl = AppSettings.API_BASE_URL + "api/";

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private httpClient: HttpClient, private auth: AuthenticationService) { }

  private handleError<T>(operation = 'operation', result?: T) {
    let errorMsg = '';
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getInvoices(currentPage: number, pageSize: number, order: string, sortby: string, filter: InvoiceFilterOption): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}InvoicesCollection`;

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (filter.customerId) {
      url = url + '&customerId=' + filter.customerId;
    }
    if (filter.invoiceId) {
      url = url + '&invoiceId=' + filter.invoiceId;
    }
    if (filter.shipmentId) {
      url = url + '&shipmentId=' + filter.shipmentId;
    }
    if (filter.type) {
      url = url + '&type=' + filter.type;
    }
    if (filter.status) {
      url = url + '&status=' + filter.status;
    }
    if (filter.shippingMethod) {
      url = url + '&shippingMethod=' + filter.shippingMethod;
    }
    if (filter.invoiceCode) {
      url = url + '&invoiceCode=' + filter.invoiceCode;
    }
    if (filter.shipmentCode) {
      url = url + '&shipmentCode=' + filter.shipmentCode;
    }
    if (filter.isSent) {
      url = url + '&isSent=' + filter.isSent;
    }
    if (filter.parentInvoiceId) {
      url = url + '&parentInvoiceId=' + filter.parentInvoiceId;
    }
    if (filter.searchKey) {
      url = url + '&searchKey=' + filter.searchKey;
    }
    if (filter.bolNumber)
      url = url + '&BOLNumber=' + filter.bolNumber;

    if (filter.franchiseeId)
      url = url + '&franchiseeId=' + filter.franchiseeId;

    if (filter.isFromGlobalSearch)
      url = url + '&isFromGlobalSearch=' + filter.isFromGlobalSearch;

    if (filter.isOtherShipment)
      url = url + '&isOtherShipment=' + filter.isOtherShipment;

    if (filter.countryId)
      url = url + '&countryId=' + filter.countryId;

    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched invoices')),
      catchError(this.handleError('getinvoices', []))
    );
  }

  getInvoicesCustomerDetail(currentPage: number, pageSize: number, order: string, sortby: string, filter: InvoiceFilterOption): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}InvoicesCollection/ListCustomerDetails`;

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (filter.customerId) {
      url = url + '&customerId=' + filter.customerId;
    }
    if (filter.invoiceId) {
      url = url + '&invoiceId=' + filter.invoiceId;
    }
    if (filter.shipmentId) {
      url = url + '&shipmentId=' + filter.shipmentId;
    }
    if (filter.type) {
      url = url + '&type=' + filter.type;
    }
    if (filter.status) {
      url = url + '&status=' + filter.status;
    }
    if (filter.shippingMethod) {
      url = url + '&shippingMethod=' + filter.shippingMethod;
    }
    if (filter.invoiceCode) {
      url = url + '&invoiceCode=' + filter.invoiceCode;
    }
    if (filter.shipmentCode) {
      url = url + '&shipmentCode=' + filter.shipmentCode;
    }
    if (filter.isSent) {
      url = url + '&isSent=' + filter.isSent;
    }
    if (filter.parentInvoiceId) {
      url = url + '&parentInvoiceId=' + filter.parentInvoiceId;
    }
    if (filter.searchKey) {
      url = url + '&searchKey=' + filter.searchKey;
    }
    if (filter.bolNumber)
      url = url + '&BOLNumber=' + filter.bolNumber;

    if (filter.franchiseeId)
      url = url + '&franchiseeId=' + filter.franchiseeId;

    if (filter.isFromGlobalSearch)
      url = url + '&isFromGlobalSearch=' + filter.isFromGlobalSearch;

    if (filter.isOtherShipment)
      url = url + '&isOtherShipment=' + filter.isOtherShipment;

    if (filter.countryId)
      url = url + '&countryId=' + filter.countryId;

    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched invoices')),
      catchError(this.handleError('getinvoices', []))
    );
  }

  getInvoiceById(id: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    const url = `${apiUrl}invoice/${id}`;

    return this.httpClient.get<any>(url, httpOptions);

  }

  printInvoice(invoiceId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}invoice/${invoiceId}/print`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  printCommercialInvoice(invoiceId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}invoice/${invoiceId}/printCommercialInvoice`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  printPackageCommercialInvoice(invoiceId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}invoice/${invoiceId}/PrintPackageCommercialInvoice`;

    return this.httpClient.get<any>(url, httpOptions);
  }
  CashOnDelivery(invoiceId: number, cashOnDeliveryDTO): Observable<any> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}` + 'Invoice/' + invoiceId + "/CashOnDelivery";
    return this.httpClient.post<any>(url, cashOnDeliveryDTO, httpOptions);
  }

  getInvoiceByBolNumber(bolNumber): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    const url = `${apiUrl}Miscellaneous/ScanBOL/${bolNumber}`;

    return this.httpClient.get<any>(url, httpOptions);
  }


  updateShippingAddress(invoiceId: number, obj: any, shippingDetailId: number = null) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };


    let url = `${apiUrl}directShipments/${invoiceId}/updateAddress/${shippingDetailId}`;

    return this.httpClient.patch<number>(url, obj, httpOptions);
  }

  printDHLLable(invoiceId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}printlabel/DirectDHL/` + invoiceId;

    return this.httpClient.get<any>(url, httpOptions);
  }

  printFedExLable(invoiceId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}printlabel/DirectDHL/` + invoiceId;

    return this.httpClient.get<any>(url, httpOptions);
  }

  getInvoicesForFranchisee(currentPage: number, pageSize: number, order: string, sortby: string, filter: InvoiceFilterOption): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}InvoicesCollection/GetCollection`;

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (filter.customerId) {
      url = url + '&customerId=' + filter.customerId;
    }
    if (filter.invoiceId) {
      url = url + '&invoiceId=' + filter.invoiceId;
    }
    if (filter.shipmentId) {
      url = url + '&shipmentId=' + filter.shipmentId;
    }
    if (filter.type) {
      url = url + '&type=' + filter.type;
    }
    if (filter.status) {
      url = url + '&status=' + filter.status;
    }
    if (filter.shippingMethod) {
      url = url + '&shippingMethod=' + filter.shippingMethod;
    }
    if (filter.invoiceCode) {
      url = url + '&invoiceCode=' + filter.invoiceCode;
    }
    if (filter.shipmentCode) {
      url = url + '&shipmentCode=' + filter.shipmentCode;
    }
    if (filter.isSent) {
      url = url + '&isSent=' + filter.isSent;
    }
    if (filter.parentInvoiceId) {
      url = url + '&parentInvoiceId=' + filter.parentInvoiceId;
    }
    if (filter.searchKey) {
      url = url + '&searchKey=' + filter.searchKey;
    }
    if (filter.bolNumber)
      url = url + '&BOLNumber=' + filter.bolNumber;

    if (filter.franchiseeId)
      url = url + '&franchiseeId=' + filter.franchiseeId;

    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched invoices')),
      catchError(this.handleError('getinvoices', []))
    );
  }

  getInvoiceByBol(bolNumber: string, customerId: number): Observable<ResponseDTO> {

    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}invoice/GetInvoiceByBol/${bolNumber}?customerId=${customerId}`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  updateAbnNumber(invoiceId, abnNumber): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}invoice/${invoiceId}/UpdateABNNumber?ABNNumber=${abnNumber}`;

    return this.httpClient.patch<any>(url, {}, httpOptions);
  }

  printPackagesCommercialInvoice(): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}invoice/PrintPackagesCommercialInvoice`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  combineInvoice(invoiceIds: number[]): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}invoice/CombineConsolidationInvoices`;

    return this.httpClient.post<any>(url, invoiceIds, httpOptions);
  }

}
